'use client';

import Transition from '@/components/ui/Transition';

export default function BlockedByOnboardingTemplate({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className='flex w-full min-w-0 flex-1 md:overflow-hidden'>
      <Transition
        className='bg-background flex min-w-0 flex-1'
        skipAnimation={process.env.NEXT_PUBLIC_TEST_MODE === 'true'}
      >
        {children}
      </Transition>
    </div>
  );
}
